<script lang="ts">
  import { ChevronRight } from '@lucide/svelte'
  const { children, label } = $props()
  let displayed = $state(false)

  const onMouseEnter = () => {
    displayed = true
  }

  const onMouseLeave = () => {
    displayed = false
  }
</script>

<div
  class="context-menu-submenu"
  onmouseenter={onMouseEnter}
  onmouseleave={onMouseLeave}
  role="menuitem"
  tabindex="0"
>
  <div class="context-menu-submenu-label">
    <span>{label}</span>
    <ChevronRight size="1rem" />
  </div>
  {#if displayed}
    <div class="context-menu-submenu-container">
      <div class="context-menu-submenu-content">
        {@render children?.()}
      </div>
    </div>
  {/if}
</div>

<style lang="scss">
  .context-menu-submenu {
    position: relative;
    background: none;
    border: none;
    cursor: pointer;
    width: 100%;

    .context-menu-submenu-label {
      color: var(--context-menu-foreground);
      font-size: 0.75rem;
      text-align: start;
      min-height: 2rem;
      padding: 0 1rem;
      padding-right: 0.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 0.25rem;

      > span {
        font-size: 0.75rem;
      }

      &:hover {
        background-color: var(--context-menu-hover-background);
      }
    }

    .context-menu-submenu-container {
      position: absolute;
      left: 100%;
      top: 0;
      z-index: 99;
      padding-left: calc(0.5rem + 1px);

      .context-menu-submenu-content {
        background: var(--context-menu-background);
        border: 1px solid var(--context-menu-border);
        color: var(--context-menu-foreground);
        border-radius: 0.25rem;
        display: flex;
        flex-direction: column;
        font-size: 0.75rem;
        min-width: 7.5rem;
        overflow: hidden;
      }
    }
  }
</style>
